import {handleError} from "system/error/AppError";
import Dime from "system/dime/Dime";
import SystemModulesDispatcher from "system/modules/SystemModulesDispatcher";
import LanguageSelectModule from "system/modules/types/LanguageSelectModule";
import SplashLoader from "system/modules/types/SplashLoader";

try {
   Dime.register();

   const dispatcher = new SystemModulesDispatcher();

   dispatcher
      .registerModule(new SplashLoader())
      .registerModule(new LanguageSelectModule());

   dispatcher.dispatch();
} catch (e: unknown) {
   throw handleError(e);
}